export const headersMeusDadosLogsAcoes = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Data/Hora', width: 10, key: 'dataAcao' },
  { text: 'Usuário', width: 8, key: 'nomeCompleto' },
  // { text: 'Interface', width: 5, key: 'interfaceSisAf' },
  { text: 'Entidade', width: 5, key: 'entidade' },
  { text: 'Registro', width: 5, key: 'registroId' },
  { text: 'Ação', width: 5, key: 'tipoAcao' },
  { text: 'Detalhamento', width: 20, key: 'detalhamento' },
  { text: 'Alterações', width: 20, key: 'alteracoes' },
];

export const valoresExibidosLogsAcoes: Record<string, string> = {
  id: 'ID',
  usuarioSisaf: 'Usuário',
  dataAcao: 'Data da Ação',
  interfaceSisAf: 'Interface SisAF',
  tipoAcao: 'Tipo de Ação',
  entidade: 'Entidade',
  registroId: 'ID do registro',
  detalhamento: 'Detalhamento',
};

export const headersMeusDadosLogsAcessos = [
  { text: '', width: 2, key: '' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Data/Hora', width: 10, key: 'dataAcesso' },
  { text: 'Usuário', width: 40, key: 'usuario' },
];

export const valoresExibidosLogsAcessos: Record<string, string> = {
  id: 'ID',
  fkUsuario: 'Usuário',
  moduloDb: 'Interface',
  dataAcesso: 'Data do acesso',
};

export const fieldObjectUsuario = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
];

export const valoresExibidosLog: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',
};

export type VinculoTableRow = {
  id: string | number;
  status: string;
  nuSolicitacao: string;
  interface: string;
  setor: string;
  dataInicio: string;
  dataFim: string;
  [key: string]: any;
};
